import React from 'react';
import { connect } from 'react-redux';
import { compose, withProps, withState } from 'recompose';
import { callOnMount } from '../../behaviour/patterns';
import NavBar from '../../components/navbar/Navbar/Navbar';
import memoize from '../../lib/selectorUtils';
import { actions } from '../../store';
import { trackingDataSelector } from '../../store/selectors';

/**
 * This is the component driven from Wordpress data
 * Navbar data is already in Redux but TrackingData must be loaded
 * @param props
 * @returns {JSX.Element}
 */
const Navbar = props => {
	// console.log('Navbar View Props', { ...props });
	return <NavBar {...props} />;
}

//  Setting trackingData prop because this component has no typed Props
const withSyncTrackingData = compose(
  withState('trackingData', 'setTrackingData', {}),
  withProps(
    ({
      loadTrackingData, 
    }) => ({
    onMount() {
			loadTrackingData();
    },
  })),
  callOnMount('onMount'),
);

const dispatchTrackingDataProps = dispatch => ({
  loadTrackingData: () => dispatch(actions.loadTrackingDataThunk()),
});

const mapStateToProps = (state) => 
(
  { 
    ...state.navbar, 
    trackingData: state.trackingData 
  }
);

export default compose(
  connect(mapStateToProps),
  connect(memoize(trackingDataSelector, ( trackingData ) => ({ trackingData })), dispatchTrackingDataProps),
  withSyncTrackingData,
)(Navbar);
